import styled from '@emotion/styled';
import { ArrayTranslation, useTranslation } from '@hotjar/translations';
import { Tooltip, Text, tokens, Icon } from '@hotjar/hotsauce';
import type { EnhancedPlan, EnhancedProduct } from '@hotjar/product-catalog';

interface Feature {
  feature: string;
  tooltip: string;
}

interface Props {
  product: Pick<EnhancedProduct, 'name'>;
  plan: Pick<EnhancedPlan, 'name'>;
}

const S = {
  Container: styled.div`
    margin: ${tokens.spacer.x3} ${tokens.spacer.x2};
  `,
  Divider: styled.hr`
    width: 100px;
    height: 1px;
    background-color: ${tokens.color.neutral_300};
    margin: unset;
    margin-bottom: ${tokens.spacer.x2};
  `,
  List: styled.ul`
    margin: unset;
    padding: unset;
  `,
  Item: styled.li`
    display: flex;
    align-items: flex-start;
    margin-top: ${tokens.spacer.x1};
    list-style: none;
  `,
  Icon: styled(Icon)`
    margin-top: 2px;
    margin-left: ${tokens.spacer.x1};
  `,
};

const mapFeature = ({ feature, tooltip }: Feature): JSX.Element => {
  return (
    <S.Item key={feature}>
      <Text textType="body2" textColor="text_light">
        {feature}
      </Text>
      <Tooltip text={tooltip}>
        <S.Icon icon="info" color="text_light" />
      </Tooltip>
    </S.Item>
  );
};

export function PlanFeatures({ product, plan }: Props): JSX.Element {
  const { t } = useTranslation('checkout', {
    keyPrefix: `wizard.plan-selection-modal.${product.name}.${plan.name}`,
  });

  return (
    <S.Container>
      <S.Divider />
      <Text textType="subtitle3">{t('features-heading')}</Text>
      <S.List>
        <ArrayTranslation t={t} i18nKey="features" mapperFunction={mapFeature} />
      </S.List>
    </S.Container>
  );
}
